<template>
  <v-card v-show="!tempIsPageLoading">
    <v-container v-if="_.size(items) > 0">
      <v-row>
        <v-col class="ml-4" :md="4">
          <h3 class="headline mb-0">
            {{ $t("STORE") }} {{ items[0]["storeName"] }}
            {{ items[0]["forDate"] }}
          </h3>
        </v-col>
        <v-col :md="3">
          <h3 class="headline mb-0">
            {{ $t("REG_DATE") }}: {{ items[0]["regAt"] | formatDate }}
          </h3>
        </v-col>
        <v-col :md="3">
          <h3 class="headline mb-0">
            {{ $t("FOR_DATE") }}: {{ items[0]["forDate"] }}
          </h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col :md="4">
          <v-card-title>
            <h3 class="headline mb-0">
              {{ $t("STOCK_CONSUMPTIONS_TOTAL") }}
              {{ totalItemsSum | formatBalance }}
            </h3>
          </v-card-title>
        </v-col>
        <v-col :md="3">
          <v-card-title>
            <h3 class="headline mb-0">
              {{ $t("POLUFABRIKATI_TOTAL") }}
              {{ polufabrikatiTotal | formatBalance }}
            </h3>
          </v-card-title>
        </v-col>
        <v-col :md="3">
          <v-card-title>
            <h3 class="headline mb-0">
              {{ $t("MATERIALI_TOTAL") }}
              {{ materialiTotal | formatBalance }}
            </h3>
          </v-card-title>
        </v-col>
        <v-col :md="2">
          <v-card-title>
            <h3 class="headline mb-0">
              {{ $t("STOKI_TOTAL") }} {{ stokiTotal | formatBalance }}
            </h3>
          </v-card-title>
        </v-col>
      </v-row>
    </v-container>
    <SearchTools
      :searchQuery.sync="searchQuery"
      @do-search="doSearch"
      @do-clear="doClear"
    >
      <template v-slot:prepend>
        <b-col :sm="3">
          <FormDatepickerBase
            :type="'text'"
            :clearable="true"
            :max="maxDate"
            :i18n="{
              label: 'FROM',
              placeholder: $t('FROM')
            }"
            :date.sync="filters.fromDate"
          ></FormDatepickerBase>
        </b-col>

        <b-col :sm="3">
          <FormDatepickerBase
            :type="'text'"
            :clearable="true"
            :max="maxDate"
            :i18n="{
              label: 'TO',
              placeholder: $t('TO')
            }"
            :date.sync="filters.toDate"
          ></FormDatepickerBase>
        </b-col>
      </template>
    </SearchTools>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      :options.sync="options"
      :items-per-page="totalItems"
      :server-items-length="totalItems"
      sort-by="issueDate"
      sort-desc="true"
      :loading="isLoadingStock"
      loading-text="Loading... Please wait"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: rowsPerPageItems,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        itemsPerPageText: $t('ITEMS_PER_PAGE_TEXT')
      }"
      @update:options="getDataFromApi()"
      class="elevation-1"
    >
      <template v-slot:item.regAt="{ item }">
        {{ item.regAt | formatDateTime }}
      </template>
      <template v-slot:item.unitValue="{ item }">
        {{ item.unitValue }} ({{ item.unitShortName }})
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ searchQuery }}" found no results.
        </v-alert>
      </template>
    </v-data-table>

    <RouterLink
      to="/stock-action/stock-consumptions-ajur-numbers-list"
      class="mx-2 my-2 btn btn-outline-success font-weight-bolderndary"
    >
      {{ $t("BACK") }}
    </RouterLink>
  </v-card>
</template>
<style scoped>
tr.previewTr th {
  font-size: 18px !important;
}
</style>
<script>
//General
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import { mapGetters } from "vuex";
import SearchTools from "@/core/components/table/SearchTools.vue";
import FormDatepickerBase from "@/view/content/forms/components/FormDatepickerBase.vue";

//Stock Module
import { FETCH_STOCK_CONSUMPTIONS_AJUR_NUMBER_DETAILS } from "@/modules/stock/store/stock.module";

import { permissionMixin } from "@/core/mixins/permissionMixin.js";
import i18n from "@/core/plugins/vue-i18n";

import _ from "lodash";
import moment from "moment";

export default {
  name: "StockConsumptionListTable",
  mixins: [permissionMixin],
  data() {
    return {
      isPageLoading: true,
      tableLoading: true,
      isPreviewMode: true,
      totalItemsSum: "",
      materialiTotal: "",
      polufabrikatiTotal: "",
      stokiTotal: "",
      items: [],
      totalItems: 100,
      searchQuery: "",
      filters: {
        fromDate: null,
        toDate: null
      },
      options: {
        descending: true,
        page: 1,
        itemsPerPage: 10,
        totalItems: 100
      },
      rowsPerPageItems: [10, 20, 30, 40, 50],
      columns: {},
      cancelSource: null,
      selectedItemId: null,
      headers: [
        {
          text: this.$t("ID"),
          value: "id"
        },
        {
          text: this.$t("CODE"),
          value: "itemCode"
        },
        {
          text: this.$t("ITEM_NAME"),
          value: "name"
        },
        {
          text: this.$t("LOT"),
          value: "lot"
        },
        {
          text: this.$t("UNIT_VALUE"),
          value: "unitValue"
        },
        {
          text: this.$t("COST"),
          align: "right",
          value: "cost"
        },

        {
          text: this.$t("FOR_DATE"),
          value: "forDate"
        },
        {
          text: this.$t("AJUR_NUMBER"),
          value: "ajurNumber"
        },
        {
          align: "right",
          text: this.$t("ACCOUNTED"),
          value: "regAt",
          sortable: false,
          width: "10%"
        }
      ]
    };
  },
  components: {
    SearchTools,
    FormDatepickerBase
  },
  watch: {},
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Stock Action Items",
        route: { name: "stock-action-items-list" }
      },
      { title: "Stock Consumptions" }
    ]);
  },
  computed: {
    ...mapGetters([
      "getItems",
      "isLoadingStock",
      "isLoadingSharedStore",
      "currentUser"
    ]),
    params() {
      return {
        ...this.options,
        query: this.searchQuery,
        fromDate: this.filters.fromDate,
        toDate: this.filters.toDate,
        ajurNumber: this.$route.params.id
      };
    },
    tableHeaders() {
      let vm = this;

      return vm.headers;
    },
    maxDate() {
      return moment().format("YYYY-MM-DD");
    }
  },
  methods: {
    clearFilter(key) {
      let vm = this;
      vm.$nextTick(function() {
        this.$set(vm.filters, key, null);
      });
    },
    cancelRequest() {
      //Axios cancelSource to stop current search if new value is entered
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
      }
    },
    doSearch() {
      let vm = this;
      if (vm.options.page == 1) {
        vm.getDataFromApi();
      } else {
        vm.options.page = 1;
      }
    },
    doClear() {
      let vm = this;
      vm.searchQuery = "";
      vm.filters.fromDate = null;
      vm.filters.toDate = null;
      if (vm.options.page == 1) {
        vm.getDataFromApi();
      } else {
        vm.options.page = 1;
      }
    },
    getDataFromApi() {
      let vm = this;
      //copy current params to modify
      let params = this.params;

      params.length = params.itemsPerPage; //set how many records to fecth per page
      params.start =
        params.page == 1 ? 0 : params.itemsPerPage * (params.page - 1); //set offset
      let apiParams = vm.transformUrlParams(params);
      vm.$store
        .dispatch(FETCH_STOCK_CONSUMPTIONS_AJUR_NUMBER_DETAILS, apiParams)
        .then(data => {
          vm.tempFirstLoader = false;
          vm.$nextTick(function() {
            vm.items = data.data.items;
            vm.totalItemsSum = data.data.totalItemsSum;
            vm.materialiTotal = data.data.totalGroupedItems.materiali;
            vm.polufabrikatiTotal = data.data.totalGroupedItems.polufabrikati;
            vm.stokiTotal = data.data.totalGroupedItems.stoki;
            vm.totalItems = data.data.totalItemsCount;
            if (vm.isPageLoading == true) {
              vm.isPageLoading = false;
            }
          });
        })
        .catch(response => {
          console.log(response);
          if (response.status === 404) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Nout Found"
            });
            this.$router.push({ name: "stock-invoices-list" });
          }
        });
    },
    transformUrlParams(params) {
      let apiParams =
        "?" +
        Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");
      return apiParams;
    }
  }
};
</script>
